import { MUSIC, SFX } from '@ddt/game-engine';
import { watchEffect } from 'vue';
import { assetCatalog, audio } from './audio';
import { useMatch } from './stores/match';
import { useSession } from './stores/session';

let unlockInstalled = false;

/**
 * Decide o que toca em cada momento, como o cliente original: música do lobby (062), da sala (065) e do mapa durante a partida;
 * som de vitória ou derrota no fim; e o clique (008) em qualquer botão.
 */
export function useAudioDirector(): void {
  const session = useSession();
  const match = useMatch();
  assetCatalog().catch(() => undefined); // sem assets, o jogo segue mudo

  let lastStatus = match.game.status;
  watchEffect(() => {
    void match.gameVersion; // GameState não é reativo: isto reavalia quando o jogo muda de estado
    const status = match.game.status;
    const justFinished = status === 'finished' && lastStatus !== 'finished';
    lastStatus = status;

    if (!session.authenticated) {
      audio.stop();
      return;
    }
    if (status === 'playing') {
      audio.playFirst([match.game.mapId, MUSIC.defaultMap]);
    } else if (status === 'finished') {
      audio.stop();
      const me = match.game.me(match.myAccountId);
      const winner = match.game.result?.winner;
      if (justFinished && me && winner !== undefined) audio.sfx(me.team === winner ? SFX.win : SFX.lose);
    } else if (match.phase !== 'playing') {
      audio.playFirst([match.phase === 'room' ? MUSIC.room : MUSIC.lobby]);
    }
  });

  if (unlockInstalled || typeof window === 'undefined') return;
  unlockInstalled = true;
  // O navegador só libera som depois de um gesto: o primeiro clique ou tecla destrava a música que ficou pendente.
  const unlock = () => audio.resume();
  window.addEventListener('pointerdown', unlock);
  window.addEventListener('keydown', unlock);
  // Clique em qualquer botão (menos os que têm som próprio, marcados com data-no-click-sound).
  document.addEventListener(
    'click',
    (event) => {
      const button = (event.target as Element | null)?.closest?.('button');
      if (button && !button.disabled && !button.closest('[data-no-click-sound]')) audio.sfx(SFX.click);
    },
    true,
  );
}
